module.exports = __webpack_public_path__ + "static/media/upload_button_icon.c1dba8fc.svg";